import { css } from "@compiled/react";
import { FormattedMessage } from "react-intl";

export const ReturnToProductSubheading = () => (
    <p css={subHeaderCss}>
        <FormattedMessage
            id="return-to-product-modal.header.text"
            defaultMessage="Pick up where you left off."
        />
    </p>
);

const subHeaderCss = css({
    margin: "0 auto",
    textAlign: "center"
});
